import { render, staticRenderFns } from "./UserProjectRow.vue?vue&type=template&id=26f89880"
import script from "./UserProjectRow.vue?vue&type=script&lang=ts"
export * from "./UserProjectRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports